<template>
    <div class="gs-checkout-tracking">
        <aside class="gs-checkout-tracking__alert">
            <info-icon class="h-4 w-4 fill-current"/>
            <p>{{ $t('frontend_product_step5_note') }}</p>
        </aside>
        <div class="gs-checkout-tracking__field">
            <label>{{ $t('frontend_product_step5_custom_css_track') }}</label>
            <text-area v-model="localModel.checkout_page_options.tracking_codes"
                value="localModel.checkout_page_options.tracking_codes"
                :placeholder="$t('frontend_product_step5_custom_css_track')" />
            <span>Scripts entered here are injected into the checkout body. Use this for pixels, analytics, or custom checkout CSS.</span>
        </div>
    </div>
</template>
<script>
import InfoIcon from '@/assets/images/icons/InfoIcon.svg';

export default {
    components: {
        InfoIcon,
    },
    props: {
        model: {
            required: true,
        },
    },
    data() {
        return {
            localModel: this.model,
        };
    },
    watch: {
        localModel: {
            handler() {
                this.$emit('update-model', this.localModel);
                this.$emit('updateModel', this.localModel);
            },
            deep: true,
        },
    },
};


</script>
<style>
.gs-checkout-tracking {
    display: flex;
    flex-direction: column;
    gap: 18px;
}

.gs-checkout-tracking__alert {
    display: flex;
    gap: 10px;
    align-items: flex-start;
    padding: 14px 16px;
    color: var(--gs-muted-foreground);
    background: var(--gs-surface-subtle);
    border: 1px solid var(--gs-border);
    border-radius: var(--gs-radius-sm);
}

.gs-checkout-tracking__alert p {
    margin: 0;
    font-size: 14px;
    line-height: 1.45;
}

.gs-checkout-tracking__field {
    display: flex;
    flex-direction: column;
    gap: 8px;
}

.gs-checkout-tracking__field label {
    color: var(--gs-foreground);
    font-size: 15px;
    font-weight: 600;
}

.gs-checkout-tracking__field textarea,
.gs-checkout-tracking__field .gd-textarea,
.gs-checkout-tracking__field .text-area {
    min-height: 260px;
    font-family: Menlo, Monaco, Consolas, "Liberation Mono", monospace;
}

.gs-checkout-tracking__field span {
    color: var(--gs-muted-foreground);
    font-size: 13px;
    line-height: 1.4;
}
</style>
